import { AuthCoreModule } from '@anecdotes/auth-core';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { DataFilterModule, DataSortModule } from '@anecdotes/design-system/data-manipulation';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { DropdownAtomsModule, DropdownMenuModule } from '@anecdotes/design-system/dropdown-menu';
import { ModalsModule } from '@anecdotes/design-system/modals';
import { MultiselectModule } from '@anecdotes/design-system/multiselect';
import { PipesModule } from '@anecdotes/design-system/pipes';
import { RenderingModule } from '@anecdotes/design-system/rendering';
import { TipsModule } from '@anecdotes/design-system/tips';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { Route, RouterModule } from '@angular/router';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicFormModule } from '@anecdotes/dynamic-form';
import { CoreModule } from 'core';
import { AccountFeaturesModule } from '@anecdotes/account-features';
import { AnalysisRuleModule } from '@anecdotes/analysis-rule';
import { AppTrustCenterPageRouteSegments } from '@anecdotes/configuration-data-access';
import { ControlsSharedModule } from '@anecdotes/shared-controls';
import { PluginsUiModule } from '@anecdotes/plugins-ui';
import { HeaderComponent, TrustCenterPageLayoutComponent, TrustEmptyStateComponent, ActivityDashboardComponent } from './components';
import { AccessModule } from './modules/access/access.module';
import { AccessComponent } from './modules/access/components';
import { PreviewComponent } from './modules/preview/components';
import { PreviewModule } from './modules/preview/preview.module';
import { SettingsComponent } from './modules/settings/components';
import { SettingsModule } from './modules/settings/settings.module';
import { TrustCenterDataInitializerService, TrustCenterModalService } from './services';
import { redirectGuard } from './guards';
import { FeatureFlagsModule } from '@anecdotes/feature-flags';
import { SharedTrustCenterModule, isStandaloneRef } from '@anecdotes/shared-trust-center';
import { UiBaseHeaderComponent } from '@anecdotes/ui-base-header';
import { PublishedTrustCenterRoutes } from './constants';

const standaloneRoutes: Route[] = [
  {
    path: PublishedTrustCenterRoutes.Home,
    pathMatch: 'prefix',
    component: PreviewComponent,
  },
  {
    path: PublishedTrustCenterRoutes.Auth,
    component: PreviewComponent,
  },
];

const routes: Route[] = [
  {
    path: '',
    component: TrustCenterPageLayoutComponent,
    children: [
      {
        path: '',
        data: { featureFlag: '@trust-center' },
        children: [
          /* Handle parent path by default redirection to child routes */
          {
            path: '',
            pathMatch: 'full',
            children: [],
            canActivate: [redirectGuard],
          },
          {
            path: '',
            canActivate: [TrustCenterDataInitializerService],
            children: [
              {
                data: { featureFlag: '@trust-center-preview-page' },
                path: AppTrustCenterPageRouteSegments.Preview,
                component: PreviewComponent,
              },
              {
                path: AppTrustCenterPageRouteSegments.Access,
                component: AccessComponent,
              },
              {
                path: AppTrustCenterPageRouteSegments.ActivityDashboard,
                component: ActivityDashboardComponent,
              },
              {
                data: { featureFlag: '@trust-center-settings-page' },
                path: AppTrustCenterPageRouteSegments.Settings,
                component: SettingsComponent,
              }
            ],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [
    AuthCoreModule,
    ModalsModule,
    CommonModule,
    CoreModule,
    SettingsModule,
    AccessModule,
    PreviewModule,
    DropdownMenuModule,
    RouterModule.forChild(isStandaloneRef.isStandalone ? standaloneRoutes : routes),
    TranslateModule.forChild(),
    MatExpansionModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatMenuModule,
    MatChipsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    ControlsSharedModule,
    NgbTooltipModule,
    PluginsUiModule,
    AccountFeaturesModule,
    VirtualScrollerModule,
    ButtonsModule,
    MultiselectModule,
    TipsModule,
    DataSortModule,
    RenderingModule,
    DirectivesModule,
    PipesModule,
    DataFilterModule,
    AnalysisRuleModule,
    DropdownAtomsModule,
    FeatureFlagsModule,
    SharedTrustCenterModule,
    UiBaseHeaderComponent,
  ],
  declarations: [TrustCenterPageLayoutComponent, HeaderComponent, TrustEmptyStateComponent, ActivityDashboardComponent],
  providers: [
    TrustCenterDataInitializerService,
    TrustCenterModalService,
  ],
})
export class RemoteEntryModule {}
